import { Separator } from '@/components/ui/separator';
import { MapPin, Phone, Mail, Instagram, ExternalLink } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="relative border-t border-border/50 py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <span className="font-display text-2xl tracking-[0.3em] text-foreground font-medium block mb-4">LEOR</span>
            <p className="font-body text-xs text-muted-foreground leading-relaxed mb-4">
              Pune's premier destination for advanced skin, hair & body treatments. Where luxury meets cutting-edge technology.
            </p>
            <a
              href="https://www.instagram.com/leor.clinics/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-muted-foreground hover:text-gold transition-colors duration-300"
            >
              <Instagram className="w-4 h-4" />
              <span className="font-body text-xs">@leor.clinics</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-wider text-gold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Program Overview', 'Tier Benefits', 'Earn Points', 'Redeem', 'Badges', 'Family Program'].map((link) => (
                <li key={link}>
                  <button
                    onClick={() => {
                      const id = link.toLowerCase().split(' ')[0];
                      const el = document.querySelector(`#${id === 'tier' ? 'tiers' : id}`);
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="font-body text-xs text-muted-foreground hover:text-gold transition-colors duration-300"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Treatments */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-wider text-gold mb-4">Popular Treatments</h4>
            <ul className="space-y-2">
              {['Hydra Facial', 'Celebrity Glow', 'Emsculpt Neo', 'Cryotherapy', 'GFC Therapy', 'Morpheus 8'].map((t) => (
                <li key={t}>
                  <a
                    href="https://www.leorclinics.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-body text-xs text-muted-foreground hover:text-gold transition-colors duration-300 inline-flex items-center gap-1"
                  >
                    {t}
                    <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-wider text-gold mb-4">Visit Us</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin className="w-3.5 h-3.5 text-gold mt-0.5 flex-shrink-0" />
                <p className="font-body text-xs text-muted-foreground leading-relaxed">Koregaon Park & Aundh, Pune</p>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-3.5 h-3.5 text-gold flex-shrink-0" />
                <a href="tel:+919890691515" className="font-body text-xs text-muted-foreground hover:text-gold transition-colors duration-300">+91 98906 91515</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-3.5 h-3.5 text-gold flex-shrink-0" />
                <a href="mailto:info@leorclinics.com" className="font-body text-xs text-muted-foreground hover:text-gold transition-colors duration-300">info@leorclinics.com</a>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-10 bg-border/50" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Leor Clinics. Radiance Rewards Program.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="font-body text-xs text-muted-foreground hover:text-gold transition-colors duration-300">Terms</a>
            <a href="#" className="font-body text-xs text-muted-foreground hover:text-gold transition-colors duration-300">Privacy</a>
            <a href="https://www.leorclinics.com" target="_blank" rel="noopener noreferrer" className="font-body text-xs text-muted-foreground hover:text-gold transition-colors duration-300">leorclinics.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
